(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdb-party-noel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canvas = document.getElementById('fdb-confetti-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var W, H, pieces;

    function resize() {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }

    function makePiece() {
      var colors = ['#C9A84C','#E8D08A','#8B1A1A','#C0222E','#FFFFFF'];
      return {
        x:         Math.random() * W,
        y:         Math.random() * H - H,
        r:         Math.random() * 4 + 2,
        d:         Math.random() * 0.5 + 0.3,
        color:     colors[Math.floor(Math.random() * colors.length)],
        tiltAngle: 0,
        tiltSpeed: Math.random() * 0.07 + 0.02,
        opacity:   Math.random() * 0.5 + 0.3
      };
    }

    function init() {
      resize();
      pieces = Array.from({ length: 80 }, makePiece);
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      pieces.forEach(function (p) {
        p.tiltAngle += p.tiltSpeed;
        p.y += p.d;
        if (p.y > H) { p.y = -10; p.x = Math.random() * W; }
        ctx.beginPath();
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle   = p.color;
        ctx.ellipse(p.x + Math.sin(p.tiltAngle) * 12, p.y, p.r, p.r * 0.5, p.tiltAngle, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(draw);
    }

    window.addEventListener('resize', resize);
    init();
    draw();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
